// extracted by mini-css-extract-plugin
module.exports = {"compareModal":"styles_compareModal__14gIz"};